import tw from 'twin.macro'
import styled from 'styled-components'

// export const AppDashboardGridItemWrapper = styled.div`
//   ${tw`bg-white border border-grey-light relative  shadow-xl rounded-lg h-[480px] px-4 md:px-8 py-4 overflow-y-auto`}
// `

export const AppDashboardGridItemWrapper = styled.div`
  ${tw`bg-white border mdl:w-1/2 border-app-grey-30 relative shadow-sm rounded-2xl h-[600px] px-6 py-8 overflow-y-auto`}
`
export const AchievementSummaryCardWrapper = styled.div`
  ${tw`bg-primary-appBrand min-h-[128px] min-w-[44%] rounded-2xl flex flex-col items-center justify-center py-2 px-4`}
`
